<template>
  <div>
    <top-app-bar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    >
    </top-app-bar>
    <div class="d-flex h-full flex-column">
      <top-app-bar-drawer></top-app-bar-drawer>
      <main class="main-wrapper flex-grow-1">
        <!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
        <div
          class="view-details-header bg-primary position-relative min-h-auto"
        >
          <div class="header-image">
            <img src="/img/header-banner-new.png" alt="" />
          </div>
          <!-- <div class="header-overlay"></div> -->
          <div
            class="container container--main-header position-relative pdt-50 pdb-50 pdl-16 pdr-16"
          >
            <div
              class="t-headline3 t-color-whiteHigh font-b t-center t-line-h-39"
            >
              Please select a tag #
            </div>
            <div class="t-body1 t-center t-color-whiteHigh mgt-8">
              What interests you?
            </div>

            <div
              class="mgt-22 mgb-18 mdc-chip-set banner--chip chip--outlined main-header justify-content-center"
              role="grid"
              v-if="popularTag && popularTag.length"
            >
              <div
                class="mdc-chip pdl-20 pdr-20"
                role="row"
                v-for="(tag, index) in popularTag"
                :key="index"
                :class="firstSelectedTags.includes(tag.id) ? 'selected' : ''"
                @click="selectedTagFun(tag, firstSelectedTags)"
                @keypress="selectedTagFun(tag, firstSelectedTags)"
                tabindex="0"
              >
                <div class="mdc-chip__ripple"></div>
                <span role="gridcell">
                  <span class="mdc-chip__text t-body4 font-r">{{
                    tag.name
                  }}</span>
                </span>
              </div>
            </div>
            <div class="t-center">
              <button
                class="mdc-button mdc-button--raised bg-mainBtn b-radius4 w-160 mgb-2"
                v-if="firstSelectedTags.length > 0"
                @click="serachResultByTag1"
                @keypress="serachResultByTag1"
                tabindex="0"
              >
                <span
                  class="mdc-button__label t-body2 font-r t-color-mainBtnText"
                  >{{ $t("3196") }}</span
                >
              </button>
              <button
                class="mdc-button bg-disableBtn disabled b-radius4 w-160 mgb-2"
                v-else
              >
                <span
                  class="mdc-button__label t-body2 font-r t-color-disableBtnText"
                  >{{ $t("3196") }}</span
                >
              </button>
            </div>
          </div>
        </div>

        <div class="container main-swiper mgt-24 tag-search">
          <!-- Micro Search Result -->
          <div
            class="d-flex justify-content-between align-items-center mgt-50 mgb-16"
            v-if="
              learnMicroData &&
              learnMicroData.content &&
              learnMicroData.content.length
            "
          >
            <div
              class="t-color-headlineBlack t-headline10 font-b mgr-20 t-nowrap"
            >
              {{ $t("30235") }}
            </div>
            <div
              class="d-flex flex-grow-1 flex-wrap"
              v-if="popularTag && popularTag.length"
            >
              <template v-for="(tag, index) in popularTag">
                <div
                  :key="index"
                  v-if="selectedTags.includes(tag.id)"
                  class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center"
                >
                  #{{ tag.name }}
                  <!-- <img src="images/tag_del.png" alt="" class="w-25 h-25 tag-delete"> -->
                </div>
              </template>
            </div>

            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer t-nowrap"
              @click="goToViewAllCourse('MICRO')"
              @keypress="goToViewAllCourse('MICRO')"
              v-if="!learnMicroData.last"
              tabindex="0"
            >
              {{ $t("1902") }}
            </div>
          </div>
          <div
            class="d-grid-3-24"
            v-if="
              learnMicroData &&
              learnMicroData.content &&
              learnMicroData.content.length
            "
          >
            <div
              v-for="(learnData, indexOnline) in learnMicroData.content"
              :key="indexOnline + '_online'"
            >
              <div
                class="mdc-card cursor-pointer"
                @click="redirectToCourseDetail(learnData.id, 'MICRO')"
                @keypress="redirectToCourseDetail(learnData.id, 'MICRO')"
                tabindex="0"
              >
                <div class="mdc-card__primary-action1" tabindex="0">
                  <div class="position-relative" v-if="learnData.thumbnail">
                    <img
                      :src="learnData.thumbnail"
                      v-if="learnData.thumbnail"
                      alt=""
                      class="border-top"
                    />
                    <img src="/img/slider-placeholder.svg" v-else alt="" />
                    <div class="mdc-chip-set swiper-chip" role="grid">
                      <div class="mdc-chip h-28 t-line-h-initial" role="row">
                        <div class="mdc-chip__ripple"></div>
                        <span role="gridcell">
                          <span
                            role="button"
                            tabindex="0"
                            class="mdc-chip__primary-action"
                          >
                            <span
                              class="mdc-chip__text t-body3 pdt-2 t-color-white"
                            >
                              {{ $t("1908", { str: learnData.lessonCount }) }}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mgt-24">
                    <div class="t-headline7 pdl-24 pdr-24 font-m">
                      {{ learnData.name ? learnData.name : "" }}
                    </div>
                  </div>
                  <div class="mgt-16">
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-if="!learnData.thumbnail"
                    >
                      {{ $t("1908", { str: learnData.lessonCount }) }}
                    </div>
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-for="(level, index2) of learnData.levels"
                      :key="index2"
                    >
                      {{ level.text }}
                    </div>
                  </div>
                  <div class="mgt-2 pdl-24 mgb-16">
                    <span class="font-r t-color-headlineBlack t-body6 pdr-4"
                      >by
                    </span>
                    <span class="font-r t-color-headlineBlack t-body6">
                      {{
                        learnData.teacher ? learnData.teacher.name.fullName : ""
                      }}
                    </span>
                  </div>
                  <div
                    class="d-flex align-items-baseline pdl-24 pdb-24"
                    v-if="
                      learnData &&
                      learnData.goods &&
                      learnData.goods.paymentPrice > 0
                    "
                  >
                    <div class="t-color-headlineBlack t-body-6 pdr-4">
                      {{ learnData.goods.currency.key || "USD" }}
                    </div>
                    <div class="t-color-headlineBlack t-headline10 pdr-8">
                      {{ $n(learnData.goods.paymentPrice) }}
                    </div>
                    <div
                      class="t-body1 t-color-bodyGrayB t-line-through-red"
                      v-if="
                        learnData &&
                        learnData.goods.paymentPrice < learnData.goods.price
                      "
                    >
                      {{ $n(learnData.goods.price) }}
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-baseline pdl-24 pdb-24"
                    v-if="
                      learnData &&
                      learnData.goods &&
                      !learnData.goods.paymentPrice
                    "
                  >
                    <div class="t-color-headlineBlack t-headline10 pdr-8">
                      {{ $t("872") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Online Class Search Result -->
          <div
            class="d-flex justify-content-between align-items-center mgt-50 mgb-16"
            v-if="
              learnOnlineData &&
              learnOnlineData.content &&
              learnOnlineData.content.length
            "
          >
            <div
              class="t-color-headlineBlack t-headline10 font-b mgr-20 t-nowrap"
            >
              {{ $t("3201") }}
            </div>
            <div
              class="d-flex flex-grow-1 flex-wrap"
              v-if="popularTag && popularTag.length"
            >
              <template v-for="(tag, index) in popularTag">
                <div
                  :key="index"
                  v-if="selectedTags.includes(tag.id)"
                  class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center"
                >
                  #{{ tag.name }}
                  <!-- <img src="images/tag_del.png" alt="" class="w-25 h-25 tag-delete"> -->
                </div>
              </template>
            </div>

            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer t-nowrap"
              @click="goToViewAllCourse()"
              @keypress="goToViewAllCourse()"
              v-if="!learnOnlineData.last"
              tabindex="0"
            >
              {{ $t("1902") }}
            </div>
          </div>
          <div
            class="d-grid-3-24"
            v-if="
              learnOnlineData &&
              learnOnlineData.content &&
              learnOnlineData.content.length
            "
          >
            <div
              v-for="(learnData, indexOnline) in learnOnlineData.content"
              :key="indexOnline + '_online'"
            >
              <div
                class="mdc-card cursor-pointer"
                @click="redirectToCourseDetail(learnData.id)"
                @keypress="redirectToCourseDetail(learnData.id)"
                tabindex="0"
              >
                <div class="mdc-card__primary-action1" tabindex="0">
                  <div class="position-relative" v-if="learnData.thumbnail">
                    <img
                      :src="learnData.thumbnail"
                      v-if="learnData.thumbnail"
                      alt=""
                      class="border-top"
                    />
                    <img src="/img/slider-placeholder.svg" v-else alt="" />
                    <div class="mdc-chip-set swiper-chip" role="grid">
                      <div class="mdc-chip h-28 t-line-h-initial" role="row">
                        <div class="mdc-chip__ripple"></div>
                        <span role="gridcell">
                          <span
                            role="button"
                            tabindex="0"
                            class="mdc-chip__primary-action"
                          >
                            <span
                              class="mdc-chip__text t-body3 pdt-2 t-color-white"
                            >
                              {{ $t("1908", { str: learnData.lessonCount }) }}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mgt-24">
                    <div class="t-headline7 pdl-24 pdr-24 font-m">
                      {{ learnData.name ? learnData.name : "" }}
                    </div>
                  </div>
                  <div class="mgt-16">
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-if="!learnData.thumbnail"
                    >
                      {{ $t("1908", { str: learnData.lessonCount }) }}
                    </div>
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-for="(level, index2) of learnData.levels"
                      :key="index2"
                    >
                      {{ level.text }}
                    </div>
                  </div>
                  <div class="mgt-2 pdl-24 mgb-16">
                    <span class="font-r t-color-headlineBlack t-body6 pdr-4"
                      >by
                    </span>
                    <span class="font-r t-color-headlineBlack t-body6">
                      {{
                        learnData.teacher ? learnData.teacher.name.fullName : ""
                      }}
                    </span>
                  </div>
                  <div
                    class="d-flex align-items-baseline pdl-24 pdb-24"
                    v-if="
                      learnData &&
                      learnData.goods &&
                      learnData.goods.paymentPrice > 0
                    "
                  >
                    <div class="t-color-headlineBlack t-body-6 pdr-4">
                      {{ learnData.goods.currency.key || "USD" }}
                    </div>
                    <div class="t-color-headlineBlack t-headline10 pdr-8">
                      {{ $n(learnData.goods.paymentPrice) }}
                    </div>
                    <div
                      class="t-body1 t-color-bodyGrayB t-line-through-red"
                      v-if="
                        learnData &&
                        learnData.goods.paymentPrice < learnData.goods.price
                      "
                    >
                      {{ $n(learnData.goods.price) }}
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-baseline pdl-24 pdb-24"
                    v-if="
                      learnData &&
                      learnData.goods &&
                      !learnData.goods.paymentPrice
                    "
                  >
                    <div class="t-color-headlineBlack t-headline10 pdr-8">
                      {{ $t("872") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex justify-content-between align-items-center mgt-50 mgb-16"
            v-if="
              examIndependentData &&
              examIndependentData.content &&
              examIndependentData.content.length
            "
          >
            <div
              class="t-color-headlineBlack t-headline10 font-b mgr-20 t-nowrap"
            >
              {{ $t("3202") }}
            </div>
            <div
              class="d-flex flex-grow-1 flex-wrap"
              v-if="popularTag && popularTag.length"
            >
              <template v-for="(tag, index) in popularTag">
                <div
                  :key="index"
                  v-if="selectedTags.includes(tag.id)"
                  class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center"
                >
                  #{{ tag.name }}
                  <!-- <img src="images/tag_del.png" alt="" class="w-25 h-25 tag-delete"> -->
                </div>
              </template>
            </div>
            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer t-nowrap"
              @click="goToViewAllTest()"
              v-if="!examIndependentData.last"
              @kepress="goToViewAllTest()"
              tabindex="0"
            >
              {{ $t("1902") }}
            </div>
          </div>
          <div
            class="container main-swiper-container main-swiper pdb-1"
            v-if="
              examIndependentData &&
              examIndependentData.content &&
              examIndependentData.content.length
            "
          >
            <div class="d-grid-3-24">
              <div
                v-for="(examData, indexExam) in examIndependentData.content"
                :key="indexExam + '_exam'"
              >
                <div
                  class="mdc-card cursor-pointer"
                  @click="viewDetailExam(examData.id)"
                  @keypress="viewDetailExam(examData.id)"
                  tabindex="0"
                >
                  <div class="mdc-card__primary-action" tabindex="0">
                    <div class="position-relative" v-if="examData.image">
                      <div class="pdl-24 pdr-24 pdt-24">
                        <img
                          :src="examData.image"
                          alt=""
                          class="test-carousel-image"
                        />
                      </div>
                      <div
                        class="mdc-chip-set swiper-chip test-swiper-chip"
                        role="grid"
                      >
                        <div class="mdc-chip h-32 t-line-h-initial" role="row">
                          <div class="mdc-chip__ripple"></div>
                          <span role="gridcell">
                            <span
                              role="button"
                              tabindex="0"
                              class="mdc-chip__primary-action"
                            >
                              <span
                                class="mdc-chip__text t-body3 pdt-4 pdb-4 t-color-white font-rn"
                              >
                                {{ indexExam + 1 }}/{{
                                  examIndependentData.content.length
                                }}
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mgt-24">
                      <div
                        class="t-headline7 pdl-24 pdr-24 font-m t-line-h-28 mgb-24"
                      >
                        {{ examData.name }}
                      </div>
                      <div
                        class="d-flex align-items-baseline pdl-24 pdb-24"
                        v-if="
                          examData &&
                          examData.goods &&
                          examData.goods.paymentPrice > 0
                        "
                      >
                        <div
                          class="t-color-headlineBlack t-body-6 pdr-4 d-flex align-items-baseline"
                        >
                          {{ examData.goods.currency.key || "USD" }}
                          <div class="t-color-headlineBlack t-headline10 pdl-8">
                            {{ $n(examData.goods.paymentPrice) }}
                          </div>
                        </div>
                        <div
                          class="t-body1 t-color-bodyGrayB t-line-through-red"
                          v-if="
                            examData &&
                            examData.goods.paymentPrice < examData.goods.price
                          "
                        >
                          {{ $n(examData.goods.price) }}
                        </div>
                      </div>
                      <div
                        class="d-flex align-items-baseline pdl-24 pdb-24"
                        v-else
                      >
                        <div class="t-color-headlineBlack t-headline10 pdr-8">
                          Free
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-between align-items-center mgt-50 mgb-16"
            v-if="
              surveyIndependentData &&
              surveyIndependentData.content &&
              surveyIndependentData.content.length
            "
          >
            <div
              class="t-color-headlineBlack t-headline10 font-b mgr-20 t-nowrap"
            >
              {{ $t("3203") }}
            </div>
            <div
              class="d-flex flex-grow-1 flex-wrap"
              v-if="popularTag && popularTag.length"
            >
              <template v-for="(tag, index) in popularTag">
                <div
                  :key="index"
                  v-if="selectedTags.includes(tag.id)"
                  class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center"
                >
                  #{{ tag.name }}
                  <!-- <img src="images/tag_del.png" alt="" class="w-25 h-25 tag-delete"> -->
                </div>
              </template>
            </div>
            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer t-nowrap"
              @click="goToViewAllSurvey()"
              v-if="!surveyIndependentData.last"
              tabindex="0"
            >
              {{ $t("1902") }}
            </div>
          </div>
          <div
            class="container main-swiper-container main-swiper pdb-1"
            v-if="
              surveyIndependentData &&
              surveyIndependentData.content &&
              surveyIndependentData.content.length
            "
          >
            <div class="d-grid-3-24">
              <div
                v-for="(
                  surveyData, indexSurvey
                ) in surveyIndependentData.content"
                :key="indexSurvey + '_survey'"
              >
                <div
                  class="mdc-card cursor-pointer"
                  @click="viewDetail(surveyData.id)"
                  @keypress="viewDetail(surveyData.id)"
                  tabindex="0"
                >
                  <div class="mdc-card__primary-action" tabindex="0">
                    <div class="position-relative" v-if="surveyData.image">
                      <div class="pdl-24 pdr-24 pdt-24">
                        <img
                          :src="surveyData.image"
                          alt=""
                          class="test-carousel-image"
                        />
                      </div>
                      <div
                        class="mdc-chip-set swiper-chip test-swiper-chip"
                        role="grid"
                      >
                        <div class="mdc-chip h-32 t-line-h-initial" role="row">
                          <div class="mdc-chip__ripple"></div>
                          <span role="gridcell">
                            <span
                              role="button"
                              tabindex="0"
                              class="mdc-chip__primary-action"
                            >
                              <span
                                class="mdc-chip__text t-body3 pdt-4 pdb-4 t-color-white font-rn"
                              >
                                {{ indexSurvey + 1 }} /
                                {{ surveyIndependentData.content.length }}
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mgt-24">
                      <div
                        class="t-headline7 pdl-24 pdr-24 font-m t-line-h-28 mgb-24"
                      >
                        {{ surveyData.name }}
                      </div>
                      <div
                        class="d-flex align-items-center pdl-24 pdb-24 pdr-24"
                        v-if="surveyData.earnPoint > 0"
                      >
                        <div class="t-body6 font-r flex-grow-1">
                          {{ $t("218") }}
                        </div>
                        <div
                          class="t-subtitle1 t-center l-spacing66 d-flex align-items-center justify-content-center"
                        >
                          <img
                            src="@/assets/icon_point.svg"
                            class="w-24 h-24 d-inline mgr-4"
                            alt=""
                          />{{ $n(surveyData.earnPoint) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- No Data -->
        <div :style="divShow ? `display:block` : `display:none`">
          <div
            v-if="searchTagNoData == 'noData'"
            class="container mgt-50 t-center"
          >
            <div
              class="d-flex flex-grow-1 flex-wrap justify-content-center"
              v-if="popularTag && popularTag.length"
            >
              <div v-for="(tag, index) in popularTag" :key="index" class="">
                <div class="d-flex justify-content-center flex-wrap">
                  <div
                    class="font-b t-headline3 t-line-h-28 mgl-24 mgr-24 mgb-16"
                    v-if="selectedTags.includes(tag.id)"
                  >
                    "{{ tag.name }}"
                  </div>
                </div>
              </div>
            </div>
            <div class="t-headline8 font-r mgt-8 t-center">
              검색 결과가 없습니다.
            </div>
            <div class="t-body1 font-r t-color-bodyGrayA t-center">
              검색하신 내용을 다시 확인해주세요.
            </div>
          </div>
        </div>

        <!-- Survey -->
        <div class="container new-survey main-swiper mgb-26 tag-search">
          <div
            class="d-flex justify-content-between align-items-center mgt-50 mgb-16"
            v-if="
              boardCommunityData &&
              boardCommunityData.content &&
              boardCommunityData.content.length
            "
          >
            <div
              class="t-color-headlineBlack t-headline10 font-b mgr-20 t-nowrap"
            >
              {{ $t("3204") }}
            </div>
            <div
              class="d-flex flex-grow-1 flex-wrap"
              v-if="popularTag && popularTag.length"
            >
              <template v-for="(tag, index) in popularTag">
                <div
                  :key="index"
                  v-if="selectedTags.includes(tag.id)"
                  class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center"
                >
                  #{{ tag.name }}
                  <!-- <img src="images/tag_del.png" alt="" class="w-25 h-25 tag-delete"> -->
                </div>
              </template>
            </div>
            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer t-nowrap"
              @click="goToViewAllCommunity()"
              @keypress="goToViewAllCommunity()"
              v-if="!boardCommunityData.last"
              tabindex="0"
            >
              {{ $t("1902") }}
            </div>
          </div>

          <div
            class="d-grid-3-24"
            v-if="
              boardCommunityData &&
              boardCommunityData.content &&
              boardCommunityData.content.length
            "
          >
            <div
              v-for="(boardData, indexBoard) in boardCommunityData.content"
              :key="indexBoard + '_board'"
            >
              <div class="mdc-card mgb-24 pdt-24 pdb-12">
                <div class="pdl-24 pdr-24">
                  <div class="d-flex">
                    <div class="list-image-small">
                      <img
                        v-if="boardData.auditor.register.profile"
                        :src="boardData.auditor.register.profile"
                        class="circle icon52 h-52"
                        alt=""
                      />
                      <img
                        v-else
                        src="/images/user.png"
                        class="circle icon52 h-52"
                        alt=""
                      />
                    </div>
                    <div class="flex-grow-1 pdl-16">
                      <div class="d-flex justify-content-between">
                        <div class="t-body3 mgb-1 font-r mgb-4">
                          {{ boardData.auditor.register.name.fullName }}
                        </div>
                      </div>
                      <div class="t-body3 font-r t-color-bodyGrayA">
                        {{
                          $moment(boardData.auditor.register.time).format("L")
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="t-body3 font-r mgt-24 cursor-pointer"
                    tabindex="0"
                    @click="moveToDetail(boardData, 'community')"
                    @keypress="moveToDetail(boardData, 'community')"
                  >
                    {{ boardData.contents ? boardData.contents.subject : "" }}
                  </div>
                  <div
                    class="t-body6 font-r t-color-bodyGrayA mgt-8 l-spacing45 t-line-h-25 cursor-pointer"
                    tabindex="0"
                    @click="moveToDetail(boardData, 'community')"
                    @keypress="moveToDetail(boardData, 'community')"
                    v-if="boardData.contents && boardData.contents.body !== ''"
                  >
                    <span v-html="listFilter(boardData.contents.body)"></span>
                  </div>
                  <div
                    v-if="
                      (boardData.contents.video &&
                        getType(boardData.contents.video.contentType) ===
                          'video') ||
                      (boardData.contents.images &&
                        boardData.contents.images.length > 0 &&
                        getType(boardData.contents.images[0].contentType) ===
                          'image')
                    "
                    class="mgt-16 b-radius4 position-relative d-flex align-items-center justify-content-center mgb-8 square-image"
                  >
                    <img
                      v-if="
                        boardData.contents.images &&
                        boardData.contents.images.length > 0 &&
                        getType(boardData.contents.images[0].contentType) ===
                          'image'
                      "
                      :src="boardData.contents.images[0].resourceUri"
                      class="position-relative cursor-pointer h-full"
                      id="video-overlay"
                      @click="moveToDetail(boardData, 'community')"
                      @keypress="moveToDetail(boardData, 'community')"
                      tabindex="0"
                      alt=""
                    />
                    <video-player
                      class="video-player-box"
                      v-if="
                        boardData.contents.video &&
                        getType(boardData.contents.video.contentType) ===
                          'video'
                      "
                      ref="videoPlayer"
                      :options="getPayerOption(boardData.contents.video)"
                      :playsinline="true"
                    />
                  </div>
                  <div
                    class="d-flex mgt-4 flex-wrap"
                    v-if="boardData.tags && boardData.tags.length > 0"
                  >
                    <div
                      v-for="(tag, i) in boardData.tags"
                      :key="i"
                      class="pdl-4 pdr-4 b-radius2 mgr-4 mgt-4 t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center b-radius4 d-flex align-items-center"
                    >
                      #{{ tag.name }}
                    </div>
                  </div>
                </div>
                <div class="divider mgt-16"></div>
                <div class="d-flex pdt-16 pdb-12 pdl-24 pdr-24">
                  <div class="t-helper t-color-bodyGrayA font-r">
                    {{
                      $t("3118", {
                        str: boardData ? boardData.commentCount : "0",
                      })
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="t-headline8 t-center mgb-4">{{ $t("3313") }}</div>
            <div class="t-color-bodyGrayA t-center">{{ $t("3314") }}</div>
          </div>

          <div
            class="d-flex justify-content-between align-items-center mgt-50 mgb-16"
            v-if="
              boardSocialData &&
              boardSocialData.content &&
              boardSocialData.content.length
            "
          >
            <div
              class="t-color-headlineBlack t-headline10 font-b mgr-20 t-nowrap"
            >
              {{ $t("3205") }}
            </div>
            <div
              class="d-flex flex-grow-1 flex-wrap"
              v-if="popularTag && popularTag.length"
            >
              <template v-for="(tag, index) in popularTag">
                <div
                  :key="index"
                  v-if="selectedTags.includes(tag.id)"
                  class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center"
                >
                  #{{ tag.name }}
                  <!-- <img src="images/tag_del.png" alt="" class="w-25 h-25 tag-delete"> -->
                </div>
              </template>
            </div>
            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer t-nowrap"
              @click="goToViewAllSocial()"
              @keypress="goToViewAllSocial()"
              tabindex="0"
              v-if="!boardSocialData.last"
            >
              {{ $t("1902") }}
            </div>
          </div>
          <div
            class="d-grid-3-24"
            v-if="
              boardSocialData &&
              boardSocialData.content &&
              boardSocialData.content.length
            "
          >
            <div
              v-for="(boardData, indexSocial) in boardSocialData.content"
              :key="indexSocial + '_board'"
            >
              <div class="mdc-card mgb-24 pdt-24 pdb-12 pdl-24 pdr-24">
                <div
                  class="cursor-pointer"
                  @click="moveToDetail(boardData, 'social')"
                  @keypress="moveToDetail(boardData, 'social')"
                  tabindex="0"
                >
                  <div class="d-flex">
                    <div class="list-image-small">
                      <img
                        v-if="boardData.auditor.register.profile"
                        :src="boardData.auditor.register.profile"
                        class="circle icon52 h-52"
                        alt=""
                      />
                      <img
                        v-else
                        src="/images/user.png"
                        class="circle icon52 h-52"
                        alt=""
                      />
                    </div>
                    <div class="flex-grow-1 pdl-16">
                      <div class="d-flex justify-content-between">
                        <div class="t-body3 mgb-1 font-r mgb-4">
                          {{ boardData.auditor.register.name.fullName }}
                        </div>
                        <div class="t-body3 font-r t-color-bodyGrayA">
                          {{
                            $moment(boardData.auditor.register.time).format("L")
                          }}
                        </div>
                      </div>

                      <div
                        class="d-flex user-list-info"
                        v-if="
                          boardData.auditor &&
                          boardData.auditor.register &&
                          !checkDeactivateUser(boardData.auditor.register)
                        "
                      >
                        <div
                          class="t-body3 t-color-bodyGrayA font-r pdr-8 mgr-8"
                          v-if="boardData.auditor.register.storeName"
                        >
                          {{ boardData.auditor.register.storeName }}
                        </div>
                        <div
                          class="t-body3 t-color-bodyGrayA font-r pdr-8 mgr-8"
                        >
                          {{ boardData.auditor.register.responsibilityName }}
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="t-body3 t-color-bodyGrayA font-r pdr-8 mgr-8"
                        >
                          {{ brandName }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25"
                    v-if="boardData.contents && boardData.contents.body !== ''"
                  >
                    <span v-html="listFilter(boardData.contents.body)"></span>
                  </div>
                  <div
                    class="d-flex mgt-4 flex-wrap"
                    v-if="boardData.tags && boardData.tags.length > 0"
                  >
                    <div
                      v-for="(tag, i) in boardData.tags"
                      :key="i"
                      class="pdl-4 pdr-4 b-radius2 mgr-4 mgt-4 t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center b-radius4 d-flex align-items-center"
                    >
                      #{{ tag.name }}
                    </div>
                  </div>
                  <div
                    class="square-image mgt-16"
                    v-if="
                      boardData.contents.images &&
                      boardData.contents.images.length > 0
                    "
                  >
                    <a
                      href="javascript:void(0)"
                      @click="moveToDetail(boardData, 'social')"
                      @keypress="moveToDetail(boardData, 'social')"
                      tabindex="0"
                    >
                      <img
                        :src="boardData.contents.images[0].resourceUri"
                        alt=""
                        class="h-full"
                      />
                    </a>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center mgt-16 mgb-16"
                  >
                    <div class="d-flex flex-grow-1">
                      <div class="t-color-bodyGrayB t-helper font-r pdr-24">
                        {{ $t("1430", { str: boardData.likesCount }) }}
                      </div>
                      <div class="t-color-bodyGrayB t-helper font-r pdr-24">
                        {{ $t("1431", { str: boardData.commentCount }) }}
                      </div>
                    </div>
                    <div class="t-color-bodyGrayB t-helper font-r">
                      {{ $t("1432", { str: boardData.commentCount }) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end of show search result -->
        <div class="mgt-40"></div>
      </main>
    </div>
  </div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import socialApi from "@/api/socialApi.js";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import mainApi from "@/api/mainApi.js";
import { mapState } from "vuex";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { userMixin } from "@/mixins/user.js";

export default {
  name: "Main",
  components: {
    TopAppBar,
    TopAppBarDrawer,
    videoPlayer,
  },
  data() {
    return {
      firstSelectedTags: [],
      popularTag: null,
      selectedTags: [],
      selectedTagsName: [],
      tagSearchBtn: false,
      showSearchTagData: true,
      learnOnlineData: null,
      learnMicroData: null,
      examIndependentData: null,
      surveyIndependentData: null,
      boardCommunityData: null,
      boardSocialData: null,
      searchTagNoData: null,
      divShow: false,
      brandName: localStorage.getItem("brandName"),
    };
  },

  computed: {
    // swiper define
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    reverseItems: function () {
      return this.recommendedList.slice().reverse();
    },
    ...mapState({
      likeCount: (state) => state.social.likeCount,
      viewCount: (state) => state.social.viewCount,
      memberDetail: (state) => state.member.memberDetail,
    }),
  },

  mixins: [topAppBarMixin, userMixin],

  mounted() {
    this.firstSelectedTags = this.$route.query.selectedtag
      .split(",")
      .map(Number);
    // get tag from API
    mainApi
      .fetchPopularTag()
      .then((response) => {
        this.popularTag = response.data.data;
        this.serachResultByTag();
      })
      .catch((err) => {});
  },
  methods: {
    // Move to social learning  or Community based on condation
    moveToDetail(record, type) {
      if (type == "social") {
        if (record && record.id) {
          this.$router.push(
            "/socialLearning/" +
              record.boardDto.identifier +
              "/" +
              record.id +
              "?boardName=" +
              encodeURI(record.boardDto.name)
          );
        }
      } else {
        if (record && record.id) {
          this.$router.push(
            "/board/" +
              record.boardDto.identifier +
              "/" +
              record.id +
              "?boardName=" +
              encodeURI(record.boardDto.name) +
              "&categoryName=" +
              encodeURI(record.boardDto.boardCategory.name)
          );
        }
      }
    },
    // Move to course detail based on id
    redirectToCourseDetail(id, type) {
      this.$router.push(
        type === "MICRO"
          ? `/micro-course/${id}?type=ListNew`
          : `/degree/${id}?type=ListNew`
      );
    },
    // Move to survey view
    viewDetail(id) {
      this.$router.push({
        name: "IndependentSurveyTotalView",
        params: { distId: id },
      });
    },
    // Move to exam view
    viewDetailExam(id) {
      this.$router.push({
        name: "IndependentExamTotalView",
        params: { distId: id },
      });
    },
    // check image or video
    getType(contentType) {
      return contentType.split("/")[0];
    },
    patchLikeState(id, status, record) {
      this.$showLoading();
      let action = status
        ? socialApi.patchPostLike(record.boardDto.identifier, id)
        : socialApi.patchPostDislike(record.boardDto.identifier, id);

      action
        .then((response) => {
          this.$hideLoading();
          record.likesCount = response.data.data.likesCount;
          //this.detail.like = !status;
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    // get seclected tags function
    selectedTagFun(tag, selectedTagArr) {
      if (selectedTagArr.includes(tag.id)) {
        var selectedTagArr = selectedTagArr.filter(function (
          value,
          index,
          arr
        ) {
          return value != tag.id;
        });
      } else {
        selectedTagArr.push(tag.id);
      }
      this.firstSelectedTags = selectedTagArr;

      if (this.selectedTags.includes(tag.id)) {
        var newArray = this.selectedTags.filter(function (value, index, arr) {
          return value != tag.id;
        });
        this.selectedTags = newArray;
      }
    },

    serachResultByTag1() {
      this.$router.push({
        path: "/tagsearch",
        query: { selectedtag: this.firstSelectedTags.join(",") },
      });
    },
    // start of search result data function
    async serachResultByTag() {
      this.divShow = false;
      let params = { size: 3, tags: this.firstSelectedTags.join(",") };
      this.selectedTags = this.firstSelectedTags;
      this.$showLoading();

      try {
        // api List 생성 후 해당 api 병렬처리, (서로 결과값에 연관 관계 없음)
        const apiList = [
          {
            key: "learnOnlineData",
            apiUrl: mainApi.fetchPopularTagLearn(params),
          },
          {
            key: "learnMicroData",
            apiUrl: mainApi.fetchPopularTagMicroLearn(params),
          },
          {
            key: "examIndependentData",
            apiUrl: mainApi.fetchPopularTagExam(params),
          },
          {
            key: "surveyIndependentData",
            apiUrl: mainApi.fetchPopularTagSurvey(params),
          },
          {
            key: "boardCommunityData",
            apiUrl: mainApi.fetchPopularTagCommunity(params),
          },
          {
            key: "boardSocialData",
            apiUrl: mainApi.fetchPopularTagSocialLearning(params),
          },
        ];

        const fetchedList = await Promise.all(apiList.map((val) => val.apiUrl));
        fetchedList.forEach((val, i) => {
          const responseData = val.data.data;
          this[apiList[i].key] =
            responseData && responseData.totalPages > 0 ? responseData : null;
        });

        if (
          this.learnOnlineData === null &&
          this.examIndependentData === null &&
          this.surveyIndependentData === null &&
          this.boardCommunityData === null &&
          this.boardSocialData === null
        ) {
          this.searchTagNoData = "noData";
          this.divShow = true;
        } else {
          this.divShow = false;
          this.searchTagNoData = null;
        }
      } catch (error) {
        console.log("TAG FETCH ERROR : ", error);
      } finally {
        this.$hideLoading();
      }
    },
    // apply char limt
    listFilter(str) {
      let length = 90;
      let ending = " ...";
      let str1 = "";
      if (str.length > length) {
        str1 = str.substring(0, length - ending.length) + ending;
        return str1.replace(/(\r\n|\n|\r)/gm, "<br/>");
      } else {
        return str.replace(/(\r\n|\n|\r)/gm, "<br/>");
      }
    },
    // set parameter
    learningSetParams() {
      const params = {
        status: "LEARNING",
        name: "",
      };
      return params;
    },
    completionSetParams() {
      const params = {
        status: "COMPLETION",
        name: "",
      };
      return params;
    },
    // Move to course tag search
    goToViewAllCourse(type) {
      this.$router.push({
        name: "TagSearchCourseVA",
        query: { tags: this.firstSelectedTags.join(","), type },
      });
    },
    // Move to survey tag search
    goToViewAllSurvey() {
      this.$router.push({
        name: "TagSearchSurveyVA",
        query: { tags: this.firstSelectedTags.join(",") },
      });
    },
    // Move to exam tag search
    goToViewAllTest() {
      this.$router.push({
        name: "TagSearchTestVA",
        query: { tags: this.firstSelectedTags.join(",") },
      });
    },
    // Move to social learning tag search
    goToViewAllSocial() {
      this.$router.push({
        name: "TagSearchSocialVA",
        query: { tags: this.firstSelectedTags.join(",") },
      });
    },
    // Move to community learning tag search
    goToViewAllCommunity() {
      this.$router.push({
        name: "TagSearchCommunityVA",
        query: { tags: this.firstSelectedTags.join(",") },
      });
    },
    // Move to learn detail
    redirectToLearnDetail(id) {
      localStorage.setItem("learnDetails", "backtoMain");
      this.$router.push("/learn/" + id + "?status=LEARNING");
    },
  },
};
</script>

<style type="text/css" scoped >
.mwc-linear-progress {
  --mdc-theme-primary: red;
  --mdc-linear-progress-buffer-color: orange;
  /* Note: all that was changed from default was "fill='orange'" */
  --mdc-linear-progress-buffering-dots-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='orange'/%3E%3C/svg%3E");
}
.header-info {
  box-shadow: 0px 5px 40px var(--Shadow2);
}

.header-info-image {
  overflow: hidden;
  border-radius: 50%;
  border: 9px solid var(--SecondaryBtn);
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translate(0, -50%);
}
.header-info-image img {
  width: 62px;
  height: 62px;
  object-fit: cover;
}

.header-info-image1 {
  border-radius: 50%;
  border: 9px solid var(--DocumentWhite);
  position: absolute;
  left: 16px;
  top: 64%;
  transform: translate(0, -50%);
}
.header-info-image1 img {
  width: 62px;
  height: 62px;
  object-fit: cover;
}
.header-info-image1 img {
  border-radius: 50%;
  box-shadow: 0 10px 16px 0 var(--Shadow2);
}

.header-info1 {
  box-shadow: 3px 15px 20px 0 var(--Shadow2);
}

.headerText {
  margin-left: 96px;
  font-size: 22px;
}

/* .titleStrip p:first-child {
	font-size: 20px;
} */

.titleStrip p:nth-child(2) {
  font-size: 14px;
  color: var(--Mainbtn);
}

.navImgStrip {
  overflow-x: auto;
}

.navImgStrip a:last-child {
  margin-right: 16px;
}

.navImgStrip a img {
  min-width: 60px;
  max-width: 60px;
}

span.swiperImageIndicator {
  right: 8px;
  bottom: 8px;
  font-size: 12px;
  background: var(--Shadow2);
  border-radius: 30px;
}
.swiperSlideWrapper {
  width: 70%;
}
.swiperPercentWrapper {
  line-height: 0.5;
}
.swiperImageHolder img {
  max-height: 130px;
  object-fit: cover;
}
.swiperTitle {
  font-size: 16px;
}
.swiperSubTitle {
  font-size: 14px;
}
.cardInner {
  border-bottom: 1px solid var(--Divider);
}
.cardInner:last-child {
  border-bottom: none;
}
.swiper-slide {
  width: 232px;
}
.leaf-wrapper {
  position: absolute;
  left: 60px;
  top: -22px;
}
@media (min-width: 768px) {
  .bubble-image {
    width: 300px;
  }

  .swiperSlideWrapper {
    width: 350px;
  }
  .swiper-slide {
    width: auto;
  }
  .swiperImageHolder img {
    min-height: 235px;
    object-fit: cover;
  }
}

@media (max-width: 420px) {
  .headerText {
    font-size: 18px;
  }
}
@media (max-width: 320px) {
  .headerText {
    font-size: 15px;
  }
}
.navImgStrip > div:last-child {
  padding-right: 15px;
}
.container.main-swiper-container.new-survey img {
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
}
</style>
